// Swaps the browser's native prompt() type-to-confirm for Simplero's own
// prompt-modal, falling back to native prompt() if the modal isn't in this
// layout. See app/javascript/lib/confirm_modal_bridge.js for why this must
// be capture phase + stopPropagation (native prompt() blocked the event
// loop, so the old code could preventDefault/stopPropagation after prompt()
// returned; the modal is async and can't rely on that).
//
// Keyword matching is case-insensitive — same as the pre-modal
// typedText.toLowerCase() == keyword.toLowerCase() comparison this replaced.
// Auto-installs in the browser; the document guard keeps the match helpers
// importable under plain `node --test`.

export function strongConfirmMatches(typedText, keyword) {
  return typedText != null && typedText.toLowerCase() === keyword.toLowerCase()
}

export function strongConfirmMatchPattern(keyword) {
  const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return new RegExp(`^${escaped}$`, 'i')
}

export function installStrongConfirm() {
  document.addEventListener(
    'click',
    function (e) {
      const target = e.target.closest?.('[data-strong-confirm]')
      if (!target || target.closest('.themed-content-root')) {
        return
      }

      e.preventDefault()
      e.stopPropagation()

      const keyword = target.dataset.strongConfirmKeyword
      const message =
        target.dataset.strongConfirm +
        "\n\nType '" +
        keyword +
        "' below to confirm."

      const proceed = () => {
        target.dataset.method = target.dataset.strongConfirmMethod
        target.removeAttribute('data-strong-confirm')
        target.click()
      }

      if (document.getElementById('prompt-modal')) {
        window.dispatchEvent(
          new CustomEvent('prompt-modal:open', {
            detail: {
              message,
              match: strongConfirmMatchPattern(keyword),
              matchMsg: `Type '${keyword}' to confirm`,
              callback: proceed,
            },
          })
        )
        return
      }

      // Native fallback (modal not present in this layout)
      const typedText = prompt(message)
      if (!strongConfirmMatches(typedText, keyword)) {
        console.log("Confirmation text did not match: '" + typedText + "'")
        return
      }

      proceed()
    },
    true
  )
}

if (typeof document !== 'undefined') {
  installStrongConfirm()
}
